import { LoginModal } from "../components/login/LoginModal";

const Auth = () => {
  return <LoginModal open={true} />;
};

export default Auth;
